import React from "react";

interface LoadingIndicatorProps {
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ message = "Loading data..." }) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 w-full">
      <img 
        alt="Cadence Loader" 
        className="w-20 mb-2" 
        src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/loader.gif" 
      />
      <p className="text-slate-600 dark:text-slate-300 text-center">{message}</p>
    </div>
  );
};

export default LoadingIndicator; 